import { getSetting } from './settings';

export function resolveDisplayPref(key, tripData) {
  if (tripData && tripData[key] === true) return true;
  if (tripData && tripData[key] === false) return false;

  const local = getSetting(key);
  if (local != null) return local;

  return true;
}
